export const DEBUG = process.env.NODE_ENV === 'development';

export const API_VERSION = 'v1';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export const AXIOS_CONFIG = {
    baseURL: `${API_BASE_URL}/api/${API_VERSION}`,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 60000,
    withCredentials: true,
};

export const endpoints = {
    auth: {
        login: `/auth/login`,
        register: `/auth/register`,
        verificationCodes: `/auth/verification-codes`,
        logout: `/auth/logout`,
        resetPassword: `/auth/reset-password`
    },
    oss: {
        config: `/oss/config`,
        sts: `/oss/sts`,
        audioUrls: (courseId: string, lessonId: string) => `/oss/audio-urls/${courseId}/${lessonId}`,
        myUploadAudioUrls: (lessonId: string) => `/oss/my-upload-audio-urls/${lessonId}`
    },
    users: {
        profile: (userId: string) => `/users/${userId}`,
        updateProfile: (userId: string) => `/users/${userId}/profile`,
        deleteAccount: (userId: string) => `/users/${userId}/delete`
    },
    resources: {
        uploaded: `/resources`,
        upload: `/resources/upload`,
        save: `/resources/save`,
        lessons: `/resources/lessons`,
        delete: (fileId: string) => `/resources/${fileId}`,
        notes: (lessonId: number) => `/resources/${lessonId}/notes`
    },
    courses: {
        list: `/courses`,
        lessons: (courseId: number) => `/courses/${courseId}/lessons`,
        notes: (courseId: number, lessonId: number) => 
            `/courses/${courseId}/lessons/${lessonId}/notes`
    },
    memberPackages: `/member-packages`,
    payment: {
        createOrder: `/payment/order`,
        paymentStatus: (orderId: string) => `/payment/${orderId}/status`,
        orders: `/payment/orders`
    },
    ai: {
        getUsage: '/ai/usage',
        incrementUsage: '/ai/increment-usage',
    },
}

export const NO_SIGNATURE_ENDPOINTS = [
    endpoints.auth.login,
    endpoints.auth.register,
    endpoints.auth.verificationCodes,
];
